import React from "react";
import { useAuth } from "../context/authContext";

const Home = () => {
  const { user } = useAuth();

  const welcomeMessage = user
    ? `Bienvenido(a) ${user.displayName || user.email}`
    : "";

  return (
    <>
      <div className="hero border-1 pb-3">
        <div className="card bg-white text-white border-0 mx-3">
        <div className="card-img-top d-flex align-items-start mt-5 mb-5">
            <div className="container bg-primary opacity-75" >
              <h5 className="card-title fs-1 text fw-lighter">TESJi Shop.</h5>
              <p className="card-text fs-5 d-none d-sm-block ">
                Este es un sitio web orientado a Ecommerce, los productos que se
                ofertan aqui provienen de un reositiorio fictiocio y la
                finalidad de este proyecto es educativa con una lisencia
                opensource.
              </p>
              <p className="text-xl mb-4">{welcomeMessage}</p>
            </div>
          </div>
          <img
            className="card-img img-fluid"
            src="./assets/main.png.jpg"
            alt="Card"
            height={500}
          />
          
        </div>
      </div>
    </>
  );
};

export default Home;
